const _env = window._env_ || {};

export const msalConfig = {
  auth: {
    clientId: _env.VUE_APP_ENTRA_CLIENT_ID || process.env.VUE_APP_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${_env.VUE_APP_ENTRA_TENANT_ID || process.env.VUE_APP_ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};
